export const UPLOAD_REQUEST = 'UPLOAD_REQUEST'
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS'
export const UPLOAD_CANCEL = 'UPLOAD_CANCEL'
export const UPLOAD_FAILURE = 'UPLOAD_FAILURE'
